import chPlayImg from "../assets/ch_play.png";
import appNameImg from "../assets/logo.png";
import userListFeatureImg from "../assets/user_list_feature.png";
import videoCallImg from "../assets/video_call.png";
import videoCallFeatureImg from "../assets/video_call_feature.png";
import ComplainHandlingComponent from "../components/staticPage/complainHandling.component";
import PaymentRuleComponent from "../components/staticPage/paymentRule.component";
import PointComponent from "../components/staticPage/point.component";
import PrivacyPolicyComponent from "../components/staticPage/privacyPolicy.component";
import TermComponent from "../components/staticPage/term.component";
import TransactionRuleComponent from "../components/staticPage/transactionRule.component";
import ConfirmAdultModal from "../components/confirm/ConfirmAdultModal.components";
import "../styles/HomeLayout.css";

function HomeLayout({ children }: any) {
  const prelineText = `ファッションに関する話題をタイムラインやメッセージ、
  通話機能を使ってシェアすることができます。
  ファッションに関する悩みを解決し、
  毎日のファッションコーディネートを楽しもう！`;

  return (
    <div className="home-wrapper">
      <ConfirmAdultModal />
      {children}
      <div id="top" className="top-wrapper"></div>

      <div className="main-content">
        <section id="section1">
          <p>ビデオ通話でファッションを楽しもう</p>
          <img className="app-name-img" src={appNameImg} alt="app-name-img" />
          <img
            className="video-call-img"
            src={videoCallImg}
            alt="video-call-img"
          />
        </section>
        <section id="section2">
          <p className="title">わさびとは</p>
          <p className="preline-text">{prelineText}</p>
          <p className="preline-text-mobile">
            ファッションに関する話題をタイムラインやメッセージ、
            通話機能を使ってシェアすることができます。
            ファッションに関する悩みを解決し、
            <br />
            毎日のファッションコーディネートを楽しもう！
          </p>
        </section>
        <section id="section3">
          <h2>わさびの機能</h2>
          <div className="user-list-feature">
            <div className="user-list-description">
              <p className="title">
                気軽にメッセージを送信し、趣味が合う方と交流を深めることができます。
              </p>
              <p>
                あなた好みの趣味の方が見つかりましたら、チャットを誘ってみましょう。
              </p>
            </div>
            <div className="user-list-feature-img">
              <img
                className=""
                src={userListFeatureImg}
                alt="user-list-feature-img"
              />
            </div>
          </div>
          <div className="video-call-feature">
            <div className="video-call-feature-img">
              <img
                className=""
                src={videoCallFeatureImg}
                alt="video-call-feature-img"
              />
            </div>
            <div className="video-call-description">
              <p className="title">
                ユーザ同士でコーディネートを見せ合いながら、ファッションを相談することができます。
              </p>
              <p>
                ユーザにリアルタイムで音声通話を通じて相談することができます。
              </p>
            </div>
          </div>
        </section>
        <section id="section4">
          <TermComponent />
        </section>

        <section id="section5">
          <PrivacyPolicyComponent />
        </section>

        <section id="section6">
          <ComplainHandlingComponent />
        </section>

        <section id="section7">
          <TransactionRuleComponent />
        </section>
        <section id="section8">
          <PaymentRuleComponent />
        </section>
        <section id="section9">
          <PointComponent />
        </section>
        <section id="section10" className="payment-method">
          <p className="title">決済方法</p>
          <div className="ch-play-link">
            <img src={chPlayImg} alt="ch-play-img" />
            <p className="ch-play-title">GooglePlay決済</p>
            <p className="ch-play-subtitle">GooglePlay決済が利用可能です。</p>
          </div>
        </section>
        <div className="footer">
          <p>大阪府公安委員会　映像送信型風俗特殊営業済 第44684号</p>
          <br/>
          <p>© wasabi-fas.com</p>
        </div>
      </div>
    </div>
  );
}

export default HomeLayout;
